export default __webpack_public_path__ + "static/media/grp1_w1024.f078afe0.jpeg";